import axios from 'axios'
import BaseRequest from './BaseRequest'

export default class CsvRequest extends BaseRequest {
  getHistory(format) {
    return axios.get(`${this.baseUrl}/admin/csv/upload/histories/${format}`)
  }

  uploadCsv(form) {
    return axios.post(`${this.baseUrl}/admin/csv/upload/`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }
}
